import React from "react";
import { css } from "@emotion/react";

import ActionBox from "../components/actionBox";
import { colors } from "../assets/styles/variables";
import iconShare from "../assets/icons/icon_share.svg";
import iconFacebook from "../assets/icons/icon_facebook.svg";
import iconLine from "../assets/icons/icon_line.svg";
import iconTwitter from "../assets/icons/icon_twitter.svg";
import iconLink from "../assets/icons/icon_link.svg";

const share = css`
  display: flex;
  align-items: center;
  justify-content: center;

  > li {
    margin-left: 20px;
    border-radius: 50%;
    background-color: ${colors.white};

    &:first-of-type {
      margin-left: 0;
    }

    &.facebook {
      background-color: ${colors.facebook};
    }

    &.line {
      background-color: ${colors.line};
    }

    &.twitter {
      background-color: ${colors.twitter};
    }

    > a,
    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
  }
`;

interface Props {
  url: string;
  text?: string;
}

const Share = (props: Props) => {
  const { url, text } = props;
  const icons = [
    { name: "facebook", src: iconFacebook, width: 10, height: 20 },
    { name: "line", src: iconLine, width: 20, height: 20 },
    { name: "twitter", src: iconTwitter, width: 20, height: 16 },
    { name: "link", src: iconLink, width: 18, height: 18 }
  ];

  const shareUrl = (name: string) => {
    let snsShareUrl = "";
    if (name === "facebook") {
      snsShareUrl = `https://www.facebook.com/share.php?u=${url}`;
    } else if (name === "line") {
      snsShareUrl = `https://social-plugins.line.me/lineit/share?url=${url}`;
    } else if (name === "twitter") {
      snsShareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
    }
    return snsShareUrl;
  };

  const copyUrl = () => {
    const copyFrom = document.createElement("textarea");
    const bodyElm = document.getElementsByTagName("body")[0];
    let value = null;

    copyFrom.textContent = url;
    bodyElm.appendChild(copyFrom);
    copyFrom.select();
    value = document.execCommand("copy");
    bodyElm.removeChild(copyFrom);
    return value;
  };

  return (
    <ActionBox
      title="シェアする"
      icon={iconShare}
      iconWidth={21}
      iconHeight={24}
    >
      <ul css={share}>
        {icons.map(icon => (
          <li key={icon.name} className={icon.name}>
            {icon.name === "link" ? (
              <span onClick={() => copyUrl()}>
                <img
                  src={icon.src}
                  width={icon.width}
                  height={icon.height}
                  alt={icon.name}
                />
              </span>
            ) : (
              <a
                href={shareUrl(icon.name)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={icon.src}
                  width={icon.width}
                  height={icon.height}
                  alt={icon.name}
                />
              </a>
            )}
          </li>
        ))}
      </ul>
    </ActionBox>
  );
};

export default Share;
